export enum AdvancedQueryOperatorOptions {
  queryString = 'query-string',
  simpleQueryString = 'simple-query-string',
}
